<div class="spinner-border" [ngClass]="colorClass" role="status" [style.width.rem]="width" [style.height.rem]="height" [style.font-size]="fontSize">
  <span class="sr-only">Loading...</span>
</div>
